import {ExtendedError} from '../../../libs/shared/helpers/src/types/customErrors';
import {reportToBugsnag} from '../../../srcCommon/services/bugsnag/bugsnag';
import {AppStore} from '../../store/appStore';
import {getCalendarWeekStartDay} from '../../store/data/preferences/preferencesSelectors';
import {updateCalendarWeekStartDayAction} from '../../store/panels/calendars/calendarsPanelActions';
import {getCalendarsPanels} from '../../store/panels/calendars/calendarsPanelSelectors';

export function setupCalendarsRefresh(store: AppStore) {
  let lastCalendarWeekStartDay = getCalendarWeekStartDay(store.getState());

  store.subscribe(async () => {
    // If the calendar week start day has not changed, nothing to do.
    const state = store.getState();
    const calendarWeekStartDay = getCalendarWeekStartDay(state);
    if (calendarWeekStartDay === lastCalendarWeekStartDay) {
      return;
    }

    lastCalendarWeekStartDay = calendarWeekStartDay;

    try {
      // Otherwise, refresh the calendars;
      const calendarsPanels = getCalendarsPanels(state);
      const navigateCalendarsPromises = calendarsPanels.map(({id}) =>
        store.dispatch(updateCalendarWeekStartDayAction(id, calendarWeekStartDay)),
      );
      await Promise.all(navigateCalendarsPromises);
    } catch (error) {
      reportToBugsnag(new ExtendedError('Error while refreshing calendars.', error));
    }
  });
}
